export default "__VITE_ASSET__0d564d62__"